import type { IconSvgObject } from './types';

const CopyleftIcon: IconSvgObject = [
  ["path", { d: "M1.99997 12C1.99997 17.5228 6.47712 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47712 2 1.99997 6.47715 1.99997 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.00003 9.35418C9.73297 8.52375 10.8053 8 12 8C14.2092 8 16 9.79086 16 12C16 14.2091 14.2092 16 12 16C10.8053 16 9.73297 15.4762 9.00003 14.6458", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CopyleftIcon;
